import gql from 'graphql-tag';

export const ContentTitleFragment = gql`
	fragment ContentTitleFragment on Content {
		id
		title
	}
`;
